import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Observable, Subscription } from 'rxjs';

import * as actions from '../../pillar/dashboard/store/actions';
import * as fromStore from '../store/reducers';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../customer.module.config';
import { AddUserModel } from '../models/AddUserModel';
import { LookupModel } from '../../common/models/LookupModel';
import { UserGroupModel } from '../models/UserGroupModel';
import { UserModel } from '../models/UserModel';
import { UserListModel } from '../models/UserListModel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.scss']
})
export class AddUserDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  eventUnsubscribe: Subscription;
  loading$: Observable<boolean>;
  errors$: Observable<string[]>;
  groupLookups$: Observable<LookupModel[]>;
  submitted: boolean = false;

  constructor(private store: Store<any>,
              public dialogRef: MatDialogRef<AddUserDialogComponent>,
              private formBuilder: FormBuilder,
              private router: Router,
              private actions$: Actions) {
    this.addForm = formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: ['', Validators.email],
      identifier: ['', Validators.required],
      group: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.errors$ = this.store.select(fromStore.getUserListErrors);
    this.loading$ = this.store.select(fromStore.getUserListLoading);
    this.eventUnsubscribe = this.actions$.ofType(actions.addSuccessType<AddUserModel>(ModuleConfiguration.moduleName, AddUserModel))
      .subscribe((a: actions.AddSuccessAction<AddUserModel>) => {
        this.router.navigateByUrl('user-workspace/' + a.payload.key);
        this.close();
      });
    this.actions$.ofType(actions.getTileErrorsType<UserListModel>(ModuleConfiguration.moduleName, UserListModel))
      .subscribe((a: actions.TileErrorsAction<UserListModel>) => {
        this.submitted = false;
      });
    this.store.dispatch(new dashboardActions.QueryListAction<UserGroupModel>(ModuleConfiguration.moduleName,
      UserGroupModel,
      {
        page: 0,
        pageSize: 2000
      }));
    this.groupLookups$ = this.store.select(fromStore.getUserGroupLookups);
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
    this.store.dispatch(new actions.ClearErrorsAction(ModuleConfiguration.moduleName, UserListModel));
  }

  add() {
    this.submitted = true;
    this.store.dispatch(new actions.AddAction(ModuleConfiguration.moduleName, AddUserModel, { model: this.addForm.value }));
  }

  lookupDisplay(lookup?: LookupModel): string | undefined {
    return lookup ? lookup.description : undefined;
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/components/add-user-dialog.component.ts